var map = {
	"./FlaxSmall.png": 2653,
	"./behodler.png": 6922,
	"./behodler.svg": 5260,
	"./burn.png": 5476,
	"./eye.png": 52,
	"./faucet.png": 1095,
	"./hedgeyIcon.png": 3972,
	"./padlock.png": 2389,
	"./pyro-scx-eth.png": 1128,
	"./pyro-scx-eye.png": 402,
	"./scarcity.png": 1845,
	"./scx-eth.png": 5855,
	"./scx-eye.png": 9397,
	"./uniswap.png": 4240,
	"./uniswap.svg": 9276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;